import React from 'react';
import { FieldArrayRenderProps } from 'formik';
import { Button } from 'react-bootstrap';
import Text from 'common/components/Text/Text';
import { CommonHash } from 'app/types';
import styles from '../LandingForm.module.scss';

interface SubComponentFormProps {
  landing_component: CommonHash;
  index: number;
  name: string;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  arrayHelpers: FieldArrayRenderProps;
  limit: number;
}

const FaqForm = ({
  landing_component,
  index,
  name,
  handleChange,
  arrayHelpers,
  limit,
}: SubComponentFormProps): React.ReactElement => {
  return (
    <>
      <Text size={22}> Faq {index + 1} </Text>
      <div className="d-flex flex-column gap-3 mt-2">
        <div className={styles.group}>
          <label htmlFor={`${name}[${index}].config['faq_question']`}>Faq Question</label>
          <input
            name={`${name}[${index}].config['faq_question']`}
            placeholder="Faq question"
            onChange={handleChange}
            required={true}
            value={landing_component.sub_landing_components[index]['config']['faq_question'] || ''}
          />
        </div>
        <div className={styles.group}>
          <label htmlFor={`${name}[${index}].config['faq_answer']`}>Faq Answer</label>
          <input
            name={`${name}[${index}].config['faq_answer']`}
            placeholder="Faq answer"
            onChange={handleChange}
            required={true}
            value={landing_component.sub_landing_components[index]['config']['faq_answer'] || ''}
          />
        </div>
        <Button
          type="button"
          variant="danger"
          className={styles.deleteButton}
          onClick={() => {
            arrayHelpers.remove(index);
          }}
        >
          Delete
        </Button>
      </div>
      {index === landing_component.sub_landing_components.length - 1 &&
        landing_component.sub_landing_components.length <= limit - 1 && (
          <Button
            type="button"
            className="mt-3"
            variant="success"
            onClick={() =>
              arrayHelpers.push({
                config: {
                  faq_question: '',
                  faq_answer: '',
                },
              })
            }
          >
            + Faq
          </Button>
        )}
    </>
  );
};

export default FaqForm;
